function influencersOfPP() {
  let infGrids = document.querySelectorAll(".infGrid");
  let whoIsThisInf = document.querySelector("#whoIsThisInf");
  let dataBranchOfInf = document.querySelector("#dataBranchOfInf");
  let dataDescOfInf = document.querySelector("#dataDescOfInf");
  let infWhoAndDesc = document.querySelector(".infWhoAndDesc");

  for (let i = 0; i < infGrids.length; i++) {
    let each = infGrids[i];
    let imgOfInf = each.querySelector(".imgOfInf");
    let yIcon = each.querySelector(".ytube-icon");
    let desc = each.getAttribute("data-desc");
    let branch = each.getAttribute("data-branch");
    each.addEventListener("mouseover", function () {
      whoIsThisInf.innerText = imgOfInf.alt;
      dataBranchOfInf.innerText = desc;
      dataDescOfInf.innerText = branch;
      yIcon.style.opacity = 1;
      infWhoAndDesc.style.display = "grid";
    });
    each.addEventListener("mouseout", function () {
      whoIsThisInf.innerText = "";
      dataBranchOfInf.innerText = "";
      dataDescOfInf.innerText = "";
      yIcon.style.opacity = 0;
      infWhoAndDesc.style.display = "none";
    });
  }
}

influencersOfPP();
